import React, { useState, useEffect } from "react";
import { isMobileDevice } from "../../utils/browserUtils";
import { useTable, useExpanded, usePagination } from "react-table";
import styles from "../../styles/GenericTable.module.scss";
import classnames from "classnames";
import Pagination from "./Pagination.jsx";

const GenericTable = (props) => {
  const { data, columns, tablePaginationProps, containerClassname } = props;
  let {wrapperId} = props
  if (typeof wrapperId==="undefined") {
    wrapperId = "tableWrapper"
  }
  const [isActive, setActive] = useState(false);
  // const [showAllRows, setShowAllRows] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);
  const tableRef = React.useRef(null);


  const scrollOption = props.scrollToOption? true: false; 
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: {
      // expanded,
      pageIndex,
      pageSize,
    },
  } = useTable(
    {
      columns: columns,
      data,
      initialState: { pageSize: tablePaginationProps.pageItem },
    },
    useExpanded,
    usePagination
  );

  const handleRowClick = (row) => {
    row.toggleRowExpanded(!row.isExpanded);
    setIsExpanded(!isExpanded);
    colorRow(row);
  };

  const colorRow = (row) => {
    let rowIdsSelected = [];
    rowIdsSelected.push(row.id);
    if (row.subRows.length) {
      row.subRows.forEach((subrow) => {
        rowIdsSelected.push(subrow.id);
      });
    }

    let activeRowIds = { ...isActive };

    rowIdsSelected.forEach((rowId) => {
      if (!isActive[rowId]) {
        activeRowIds[rowId] = true;
      } else {
        activeRowIds[rowId] = !activeRowIds[rowId];
      }
    });

    setActive(activeRowIds);
  };

  const renderRows = () => {
    return page.map((row, i) => {
      prepareRow(row);

      const rowClassnames = classnames({
        [styles.row]: true,
        [styles.expanded]: isActive[row.id],
        [styles.isSubrow]: row.id.includes("."),
      });

      return (
        <tr
          className={rowClassnames}
          onClick={() => handleRowClick(row.getRowProps(row))}
          {...row.getRowProps()}
        >
          {row.cells.map((cell) => {
            return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
          })}
        </tr>
      );
    });
  };

  const renderMobileRows = () => {
    const isActiveArray = Object.keys(isActive);
    return page.map((row, i) => {
      prepareRow(row);

      const rowClassnames = classnames({
        [styles.mobileTr]: true,
        [styles.row]: true,
        [styles.isMobileLastSubrow]:
          isActive[row.id] &&
          row.id.includes(".") &&
          row.id === isActiveArray[Object.keys(isActive).length - 1],
        [styles.isMobileSubrow]: isActive[row.id] && row.id.includes("."),
        [styles.mobileExpanded]: isActive[row.id] && !row.id.includes("."),
      });

      const tableDataClassnames = classnames({
        [styles.collapseRowSubrowBtn]:
          row.id === isActiveArray[isActiveArray.length - 1],
        // [styles.hideCollapseBtn]: true,
        [styles.collapseRowBtn]: row.subRows.length !== 0,
        [styles.hideCollapseBtn]:
          isActive[row.id] &&
          row.id.includes(".") &&
          row.id !== isActive[Object.keys(isActive).length - 1],
      });

      return (
        <tr
          className={rowClassnames}
          onClick={() => handleRowClick(row.getRowProps(row))}
          {...row.getRowProps()}
        >
          {row.cells.map((cell, i) => {
            return (
              <td {...cell.getCellProps()} className={styles.mobileRowData}>
                {headerGroups[1].headers[i]["id"] !== "expander" ? (
                  <div>
                    <p>{headerGroups[1].headers[i]["Header"]}</p>
                    <div>{cell.render("Cell")}</div>
                  </div>
                ) : (
                  <div>
                    <div className={tableDataClassnames}>
                      {cell.render("Cell")}
                    </div>
                  </div>
                )}
              </td>
            );
          })}
        </tr>
      );
    });
  };

  const TableHeader = () => {
    return (
      <thead className={styles.tableHeader}>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => {
              return (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              );
            })}
          </tr>
        ))}
      </thead>
    );
  };

  const TableBody = () => {
    return (
      <tbody {...getTableBodyProps()}>
        {isMobileDevice() ? renderMobileRows() : renderRows()}
      </tbody>
    );
  };

  useEffect(() => {
    const tableHeight = tablePaginationProps.pageItem * tablePaginationProps.rowHeight + 140;
    const element = document.getElementById(wrapperId)
    if(element) {
      element.style.minHeight = tableHeight + "px";
    }
  }, [tablePaginationProps.pageItem, tablePaginationProps.rowHeight, wrapperId]);


  const PaginationProps = {
    tablePaginationProps,
    canPreviousPage,
    nextPage,
    canNextPage,
    pageCount,
    gotoPage,
    pageIndex,
    pageOptions,
    setPageSize,
    previousPage,
    pageSize,
    tableRef,
    scrollOption,
  };

  // function handleShowAllRows() {
  //   if (showAllRows) {
  //     setPageSize(-1);
  //   } else {
  //     setPageSize(tablePaginationProps.pageItem);
  //   }
  //   setShowAllRows(!showAllRows);
  // }

  return (
    <div className={classnames(styles.genericTable, containerClassname)} ref={tableRef}>
      <div className={styles.tableWrapper} id={wrapperId} >
        <table {...getTableProps()}>
          <TableHeader />
          <TableBody />
        </table>
      </div>

      <Pagination {...PaginationProps} />
      {/* {page.length > 1 && (
        <div className={styles.showAllRowsBtnWrapper}>
          <button
            onClick={() => handleShowAllRows()}
            className={styles.showAllRowsBtn}
          >
            {showAllRows ? `Load More` : `Show Less`}
          </button>
        </div>
      )} */}
    </div>
  );
};

export default GenericTable;
